import { parse } from 'query-string'
import { useHistory } from 'react-router-dom'
import type { History } from 'history'

/*
  Checks for `?app=true` to tell if the site
  is being displayed from the App WebView.
  We could also check user agent however
  the app will pass this query param.
*/

export const isAppWebView = (history: History): boolean => {
  const query = parse(history.location.search)
  const isApp = query['app'] === 'true'
  return isApp
}

export const useAppWebView = (): boolean => {
  const history = useHistory()
  return isAppWebView(history)
}
